import React from 'react';
import useFadeIn from '../hooks/useFadeIn';

const logos = [
  { name: 'UNC Health',           file: 'UNC.png'               },
  { name: 'Trinity Health',       file: 'Trinity.png'           },
  { name: 'Johns Hopkins',        file: 'John Hopkins.jpg'      },
  { name: 'Providence',           file: 'Providence.png'        },
  { name: 'Stanford',             file: 'stanford.png'          },
  { name: 'Mayo Clinic',          file: 'mayo clinic.png'       },
  { name: 'Intermountain',        file: 'Intermountain.jpg'     },
  { name: 'Michigan Medicine',    file: 'Michigan medicine.png' },
  { name: 'OSU',                  file: 'OSU.jpg'               },
  { name: 'MercyOne',             file: 'mercyone.png'          },
  { name: 'Carle Health',         file: 'Carle health.png'      },
  { name: 'WVU Medicine',         file: 'WVU.jpg'               },
];

function LogoTicker() {
  const [ref, isVisible] = useFadeIn();

  return (
    <section className="bg-white px-0 pt-2 pb-16 md:pt-4 md:pb-20">
      <div
        ref={ref}
        className={`fade-in-section ${isVisible ? 'is-visible' : ''} flex flex-col items-center gap-8`}
      >
        <p className="text-[13px] text-[#86868b] text-center tracking-widest uppercase font-medium px-8">
          Trusted by teams at leading health systems
        </p>

        {/* Gradient fade edges + ticker */}
        <div className="relative w-full">
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

          <div className="overflow-hidden">
            <div className="ticker-track">
              {[...logos, ...logos].map((logo, i) => (
                <div key={i} className="h-11 flex items-center justify-center flex-shrink-0 mx-12">
                  <img
                    src={`${process.env.PUBLIC_URL}/logos/${logo.file}`}
                    alt={logo.name}
                    className="h-full w-auto object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'block';
                    }}
                  />
                  <span className="text-sm text-[#86868b] hidden">{logo.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default LogoTicker;
